import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import MetaTags from "react-meta-tags";

import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import { connect } from "react-redux";
import { fetchUser, saveUser } from "../../redux/actions/userAction";
import { useToasts } from "react-toast-notifications";
import ImageUploader from "react-images-upload";
import {
  changeData,
  fetchAnagraficaWithResult,
  uploadFile,
} from "../../helpers/dbOperations";
import { Link } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import { Box, makeStyles, Paper, Tabs, Typography } from "@material-ui/core";
import MaterialTable from "material-table";
import { fetchAnagrafica, fetchSendCartData } from "../../helpers/dbOperations";
import CustomerModal from "./modals/modalCustomer";
import { Modal } from "react-bootstrap";
import { Article } from "./animationList";
import ReactLoading from "react-loading";

const Colors = ({ location, userData, saveUser }) => {
  const useStyles = makeStyles({
    root: {
      flexGrow: 1,
    },
    mymodal: {
      width: "20vw" /* Occupy the 90% of the screen width */,
      maxWidth: "20vw",
    },
  });
  var informazioni = global.informazioni;

  var strings = require("../../translations/italian.json");
  const [value, setValue] = React.useState(0);
  const classes = useStyles();
  const [docs, setDocs] = useState([]);
  const [showModalCustomer, setShowModalCustomer] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [customerArray, setCustomerArray] = useState([]);
  const [onClick, setOnClick] = useState(0);
  const [idCli, setIdCli] = useState(0);
  const [inCaricamentoCheckOut, setinCaricamentoCheckOut] = useState(false);
  const [wait, setWait] = useState(false);
  const [listino, setListino] = useState("");

  var _sper = sessionStorage.getItem("personal");
  if (_sper === "undefined") _sper = null;
  const personal = _sper ? JSON.parse(_sper) : {};

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const SegliAnagrafica = (risultatoAnagrafica) => {
    setModalTitle("Scegli il cliente");
    risultatoAnagrafica.Anagrafica.map((item) => {
      item.value = item.RagSoc;
      item.id = item.IdCli;
      return item;
    });
    setCustomerArray(risultatoAnagrafica.Anagrafica);
    setOnClick(1);
    setShowModalCustomer(true);
  };
  const caricaAnagrafica = async () => {
    //console.log("carica anagrafica")
    var username = userData.user.user.username;
    var password = userData.user.user.password;
    var indexAnagraficaScelta = 0;
    var indexSede = 0;
    var risultatoAnagrafica = {};
    fetchAnagraficaWithResult({ username, password })
      .then((res) => res.json())
      .then((result) => {
        //console.log(result)
        if (!result || !result.Anagrafica) return result;

        if (result.Anagrafica.length > 1) {
          indexAnagraficaScelta = SegliAnagrafica(result);
        } else {
          setIdCli(result.Anagrafica[0].IdCli);
          setCustomerArray(result.Anagrafica);
        }
        return result;
      });
  };
  useEffect(() => {}, [idCli]);

  useEffect(() => {
    if (personal.IDLis == 29) setListino("/files/LISTINO 2.pdf");
    if (personal.IDLis == 30) setListino("/files/LISTINO 1.pdf");
    if (personal.IDLis == 31) setListino("/files/LISTINO 3.pdf");
    if (personal.IDLis == 32) setListino("/files/LISTINO CAMPANA.pdf");
    if (personal.IDLis == 33) setListino("/files/LISTINO 5 TOP.pdf");
    if (personal.IDLis == 34) setListino("/files/LISTINO 4 SPECIAL.pdf");
  }, []);

  function downloadFile(LIdDoc, CodSezVen, datDoc, numOrd) {
    setWait(true);
    var endpoint = global.endpoint + "pegaso/webAppDocPDF";
    var body = JSON.stringify({ IdDoc: LIdDoc });
    fetch(endpoint, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
      body: body,
      withCredentials: false,
    })
      .then((res) => res.blob())
      .then((blob) => {
        // 2. Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${CodSezVen}_N°${numOrd}_${datDoc}.pdf`);
        // 3. Append to html page
        document.body.appendChild(link);
        // 4. Force download
        link.click();
        // 5. Clean up and remove the link
        link.parentNode.removeChild(link);
        setWait(false);
      });
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        style={{ width: "100%" }}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  return (
    <Fragment>
      <MetaTags>
        <title>
          {strings.my_pricelist} | {informazioni.titleSite}
        </title>
        <meta
          name="description"
          content={strings.my_pricelist + " " + strings.siteContent}
        />
      </MetaTags>

      <LayoutOne headerTop="invisible">
        {/* breadcrumb 
        <Breadcrumb />*/}

        <div className="login-register-area pt-100 pb-100">
          <div className="container">
            <div className="row">
              <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/icon?family=Material+Icons"
              />

              <div>
                <div
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <a
                    href={
                      "https://dgaplanetshirt.com/files/cartelle_colori/FRUIT.pdf"
                    }
                    target="_blank"
                    style={{
                      padding: "1%",
                      border: "1px dotted black",
                      width: "25%",
                      textAlign: "center",
                    }}
                    //download="Cartella_colori_Fruit.xlsx"
                  >
                    <img
                      src="https://upload.wikimedia.org/wikipedia/en/thumb/0/0d/Fruit_logo.svg/1200px-Fruit_logo.svg.png"
                      style={{ width: "35%" }}
                    />
                  </a>{" "}
                  &nbsp;
                  <a
                    href={
                      "https://dgaplanetshirt.com/files/cartelle_colori/JHK.pdf"
                    }
                    target="_blank"
                    style={{
                      padding: "1%",
                      border: "1px dotted black",
                      width: "25%",
                      textAlign: "center",
                    }}
                    //download="Cartella_colori_JHK.pdf"
                  >
                    <img
                      src="https://www.jhktshirt.com/images/logo.png"
                      style={{ width: "35%" }}
                    />
                  </a>
                </div>
                <div
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <a
                    href={
                      "https://dgaplanetshirt.com/files/cartelle_colori/RUSSEL.pdf"
                    }
                    target="_blank"
                    style={{
                      padding: "1%",
                      border: "1px dotted black",
                      width: "25%",
                      textAlign: "center",
                    }}
                    //download="Cartelle_colori_Russell.pdf"
                  >
                    <img
                      src="https://www.images-magazine.com/wp-content/uploads/2022/01/Russell-Europe-2022-logo.jpg"
                      style={{ width: "35%" }}
                    />
                  </a>{" "}
                  &nbsp;
                  <a
                    href={
                      "https://dgaplanetshirt.com/files/cartelle_colori/VELILLA.pdf"
                    }
                    target="_blank"
                    style={{
                      padding: "1%",
                      border: "1px dotted black",
                      width: "25%",
                      textAlign: "center",
                    }}
                    //download="Cartella_colori_Velilla.pdf"
                  >
                    <img
                      src="https://www.tuttoperlasicurezza.it/img/m/20.jpg"
                      style={{ width: "35%" }}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

Colors.propTypes = {
  location: PropTypes.object,
  userData: PropTypes.object,
  cartData: PropTypes.array,
  compareData: PropTypes.array,
  currency: PropTypes.object,
  removeFromCart: PropTypes.func,
  wishlistData: PropTypes.array,
  setToken: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveUser: (user, addToast) => {
      dispatch(saveUser(user, addToast));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Colors);
